import { render } from "./accountConnect.vue?vue&type=template&id=84d4f03a&scoped=true&ts=true"
import script from "./accountConnect.vue?vue&type=script&lang=ts"
export * from "./accountConnect.vue?vue&type=script&lang=ts"

import "./accountConnect.vue?vue&type=style&index=0&id=84d4f03a&lang=scss&scoped=true"

import exportComponent from "/Users/hari/Project/FunctionX/fx-redpack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84d4f03a"]])

export default __exports__